var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"content",staticClass:"content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('loadingLottieAll',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }